import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { PlusIcon } from '../../../custom_shared/icons';
import { useAppStore } from '../../stores';
import { ButtonWithIcon } from '../../../custom_shared/components';
import { ActionParams } from '../../types';
import { useContractActions } from '../../context/ContractActionContext';
import { Actions } from '../../stores/ActionStore';

interface Props {
    actionParams: ActionParams;
}

const AddLimitButton: React.FC<Props> = ({ actionParams }: Props) => {
    const { controlStateStore } = useAppStore();

    const contractActions = useContractActions();

    return (
        <ButtonWithIcon
            label="Add new limit type..."
            icon={<PlusIcon />}
            onClick={() => contractActions.dispatch(Actions.AddLimit, actionParams)}
            disabled={controlStateStore.actionsDisabled}
        />
    );
};

export default observer(AddLimitButton);
